import { cn } from '@shared/utils';
import { Card, type TariffJsonResponse } from '@shared/api';

const getCard = (type: Card) => {
  switch (type) {
    case Card.Elite:
      return (
        <>
          {type}
          <br />
          <span className='normal-case'>(Supplementary only)</span>
        </>
      );
    default:
      return type;
  }
};

interface TariffTableProps {
  className?: string;
  tariffs: TariffJsonResponse;
}

export const TariffTable = (props: TariffTableProps) => {
  return (
    <div className={cn(props.className)}>
      <div className='mx-auto mb-8 w-full max-w-290 overflow-x-auto'>
        <table className='w-full border-collapse border border-[#dfe0e2] text-[10px] font-light text-[#1d1d1b]'>
          <tbody>
            <tr>
              <td className='h-7 border border-[#dfe0e2] bg-[#3c3c3b] px-2 py-1 text-center align-top font-bold whitespace-nowrap text-[#fefefe] uppercase' />
              {props.tariffs.cards.map((card, idx) => (
                <td
                  key={idx}
                  className='h-7 border border-[#dfe0e2] bg-[#3c3c3b] px-2 py-1 text-center align-top font-bold whitespace-nowrap text-[#fefefe] uppercase'
                >
                  {getCard(card.card)}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Currencies
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a1'>
                    1
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.currencies}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Card Type</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.cardType}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>Jewellery Card Production Cost</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.jewelleryCardProductionCost}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Annual Fee
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a2'>
                    2
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                  {card.annualFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Dual Annual Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.dualAnnualFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Supplementary Cards
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a3'>
                    3
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                  {card.supplementaryCards}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Card Replacement Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                  {card.cardReplacementFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                PIN Change Fee
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a4'>
                    4
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.pinChangeFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Printed Statement Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.printedStatementFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Insignia Online Network</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.insigniaOnlineNetwork}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Emergency Card Delivery Fee
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a5'>
                    5
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.emergencyCardDeliveryFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Late Payment Fee
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a6'>
                    6
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.latePaymentFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Late Payment Interest
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a7'>
                    7
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.latePaymentInterest}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Exchange Rate Conversion Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.exchangeRateConversionFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>Original Credit Transaction</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.originalCreditTransaction}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Quarterly Administrative Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.quarterlyAdministrativeFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Administrative Investigation Fee
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a8'>
                    8
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.administrativeInvestigationFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>VISA Arbitration Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.visaArbitrationFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                Daily Spending Limit
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a9'>
                    9
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.dailySpendingLimit}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>
                ATM Withdrawal Fee
                <sup className='ml-0.5'>
                  <a className='text-inherit no-underline hover:underline' href='#a10'>
                    10
                  </a>
                </sup>
              </td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.atmWithdrawalFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Cash-desk Withdrawal Fee</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.cashDeskWithdrawalFee}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Limit per Billing Cycle</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.limitPerBillingCycle}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Billing Cycle</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.billingCycle}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Minimum Upload</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.minimumUpload}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Transfer Fee In / Upload</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.transferFeeInUpload}
                </td>
              ))}
            </tr>
            <tr>
              <td className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top'>Transfer Fee Out</td>
              {props.tariffs.cards.map((card, idx) => (
                <td key={idx} className='h-7 w-30.5 border border-[#dfe0e2] px-2 py-1 align-top whitespace-nowrap'>
                  {card.transferFeeOut}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <ol className='mx-auto w-full max-w-290 p-0 text-[10px] text-[#4c4c4c]'>
        <li>
          <a id='a1' className='text-[7px]'>
            1
          </a>
          All figures are in the billing currency of the relevant card.
        </li>
        <li>
          <a id='a2' className='text-[7px]'>
            2
          </a>
          An Annual Fee is applied on the first cycle date after the account opening date and on each anniversary of the account opening date.
        </li>
        <li>
          <a id='a3' className='text-[7px]'>
            3
          </a>
          For Wellness Card: Additional cards can be personalised on Wellness Ceramic card. Additional costs may apply.
        </li>
        <li>
          <a id='a4' className='text-[7px]'>
            4
          </a>
          Subject to ATM availabilty.
        </li>
        <li>
          <a id='a5' className='text-[7px]'>
            5
          </a>
          Emergency cards are delivered worldwide within 72 hours, separate charges apply.
        </li>
        <li>
          <a id='a6' className='text-[7px]'>
            6
          </a>
          Applied to the Card Outstanding Balance on the day following the Payment Due Date if the balance is not paid in full.
        </li>
        <li>
          <a id='a7' className='text-[7px]'>
            7
          </a>
          Accrues daily on the Card Outstanding Balance from the Payment Due Date until the balance is paid in full.
        </li>
        <li>
          <a id='a8' className='text-[7px]'>
            8
          </a>
          Per transaction where valid proof of purchase is provided.
        </li>
        <li>
          <a id='a9' className='text-[7px]'>
            9
          </a>
          For transactions exceeding these limits, please notity Customer Service 48 to 72 hours in advance.
        </li>
        <li>
          <a id='a10' className='text-[7px]'>
            10
          </a>
          Additional fees may be imposed by the ATM provider. Please verify with the ATM provider before making use of the ATM.
        </li>
      </ol>
    </div>
  );
};
